import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";
export default function OrderDetails() {
  const { state: initialState } = useLocation();
  const navigate = useNavigate();
  const [order, setOrder] = useState(initialState);
  const [showAdModal, setShowAdModal] = useState(false);
  const [adTimer, setAdTimer] = useState(5);
  const [downloaded, setDownloaded] = useState({});
  const [pendingDownloadUrl, setPendingDownloadUrl] = useState("");
  const [concepts, setConcepts] = useState([]);
  // --- ZOOM STATES ---
  const [zoomData, setZoomData] = useState({
    show: false,
    x: 0,
    y: 0,
    img: "",
  });
  const BASE_URL = UPLOADS.DESIGN_EMB;
  useEffect(() => {
    fetchConcepts();
  }, []);

  const fetchConcepts = async () => {
    try {
      const res = await fetch(API.CONCEPT_LIST);
      const data = await res.json();
      if (data.status) {
        setConcepts(data.data);
      }
    } catch (error) {
      console.log("Concepts fetch error:", error);
    }
  };
  const getConceptNames = (conceptIds) => {
    if (!conceptIds || !Array.isArray(conceptIds)) return "N/A";

    return (
      conceptIds
        .map((id) => {
          const concept = concepts.find((c) => c.id == id);
          return concept ? concept.concept_name : null;
        })
        .filter(Boolean)
        .join(", ") || "N/A"
    );
  };
  const fetchOrderUpdates = useCallback(() => {
    if (order?.user_id && order?.id) {
      fetch(`${API.LIST_USER_ORDERS}&user_id=${order.user_id}`)
        .then((res) => res.json())
        .then((data) => {
          const allOrders = Array.isArray(data) ? data : data.orders || [];
          const updatedOrder = allOrders.find((o) => o.id === order.id);
          if (updatedOrder) setOrder(updatedOrder);
        })
        .catch((err) => console.error("Update error:", err));
    }
  }, [order?.id, order?.user_id]);

  useEffect(() => {
    if (order && order.status?.toLowerCase() !== "confirmed") {
      const intervalId = setInterval(() => fetchOrderUpdates(), 10000);
      return () => clearInterval(intervalId);
    }
  }, [order?.status, fetchOrderUpdates]);

  const handleDownloadClick = (e, file, designCode, index) => {
    e.preventDefault();

    const url = file;

    setPendingDownloadUrl({
      url,
      code: designCode,
      index,
    });

    setAdTimer(30);
    setShowAdModal(true);
  };

  useEffect(() => {
    let interval;
    if (showAdModal && adTimer > 0) {
      interval = setInterval(() => {
        setAdTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showAdModal, adTimer]);

  if (!order)
    return <div className="text-center mt-5">No order data found.</div>;

  const isConfirmed = order.status?.toLowerCase() === "confirmed";
  const handleMouseMove = (e, imgUrl) => {
    const { left, top, width, height } =
      e.currentTarget.getBoundingClientRect();

    // Calculate cursor position relative to the image container
    const xPos = e.clientX - left;
    const yPos = e.clientY - top;

    // Calculate percentage for background position
    const xPercent = (xPos / width) * 100;
    const yPercent = (yPos / height) * 100;

    setZoomData({
      show: true,
      x: xPos,
      y: yPos,
      xP: xPercent,
      yP: yPercent,
      img: imgUrl,
    });
  };

  return (
    <div className="order-details-container px-3 py-5 bg-white">
      <div className="container">
        {/* HEADER SECTION (Same as yours) */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="fw-bold">Order {order.order_no}</h2>
          <button
            className="btn btn-light border btn-sm"
            onClick={() => navigate("/myorders")}
          >
            <i className="bi bi-arrow-left"></i>Back
          </button>
        </div>

        <div className="row">
          <div className="col-lg-4 mb-4">
            {/* PAYMENT SUMMARY (Same as yours) */}
            {/* <div className="payment-summary-card p-4 border rounded shadow-sm">
                 <h5 className="fw-bold mb-4">Payment Summary</h5>
                 <div className="d-flex justify-content-between">
                    <span>Total Amount:</span>
                    <span className="fw-bold" style={{ color: "#00a99d" }}>Rs. {order.total_amount}</span>
                 </div>
            </div> */}
          </div>

          <h5 className="fw-bold mb-4">Ordered Designs</h5>

          <div className="table-responsive">
            <table className="table table-bordered align-middle order-table">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Design Image</th>
                  <th>Design Code</th>
                  <th>Area</th>
                  <th>Stitch</th>
                  <th>Color</th>
                  <th>Concept</th>
                  <th>Details</th>
                  <th>Status</th>
                  <th>Download</th>
                </tr>
              </thead>

              <tbody className="table-light">
                {order.items?.map((item, i) => {
                  let conceptIds = [];
                  try {
                    if (
                      item.concepts_array &&
                      Array.isArray(item.concepts_array)
                    ) {
                      conceptIds = item.concepts_array;
                    } else if (item.concepts) {
                      conceptIds = JSON.parse(item.concepts || "[]");
                    }
                  } catch (e) {
                    console.log("Concept parse error:", e);
                  }
                  const conceptNames = getConceptNames(conceptIds);

                  return (
                    <tr key={i}>
                      <td data-label="#">{i + 1}</td>

                      <td data-label="Image">
                        <div
                          className="design-img-box position-relative"
                          style={{
                            height: "120px",
                            cursor: isConfirmed ? "zoom-in" : "default",
                          }}
                          onMouseMove={
                            isConfirmed
                              ? (e) =>
                                  handleMouseMove(
                                    e,
                                    `${BASE_URL}${item.jpeg_file}`,
                                  )
                              : null
                          }
                          onMouseLeave={() =>
                            setZoomData({ ...zoomData, show: false })
                          }
                        >
                          {isConfirmed ? (
                            <>
                              <img
                                src={`${BASE_URL}${item.jpeg_file}`}
                                alt="Design"
                                className="w-100 h-100 object-fit-contain"
                              />
                              <div
                                className="zoom-lens"
                                style={{
                                  display:
                                    zoomData.show &&
                                    zoomData.img ===
                                      `${BASE_URL}${item.jpeg_file}`
                                      ? "block"
                                      : "none",
                                  backgroundImage: `url(${zoomData.img})`,
                                  backgroundPosition: `${zoomData.xP}% ${zoomData.yP}%`,
                                  left: `${zoomData.x}px`,
                                  top: `${zoomData.y}px`,
                                }}
                              />
                            </>
                          ) : (
                            <div className="text-muted text-center mt-4">
                              <i className="bi bi-lock-fill d-block fs-2"></i>
                              Locked
                            </div>
                          )}
                        </div>
                      </td>

                      <td data-label="code">
                        <span className="fw-semibold">{item.design_code}</span>
                      </td>
                      <td data-label="Area">{item.area}</td>
                      <td data-label="stitch">{item.stitch}</td>
                      <td data-label="color">{item.color}</td>

                      <td
                        data-label="Concept"
                        className="small"
                        title={conceptNames}
                      >
                        {conceptNames.length > 20
                          ? `${conceptNames.substring(0, 20)}...`
                          : conceptNames}
                      </td>

                      <td data-label="Details" className="small">
                        {item.details || "N/A"}
                      </td>

                      <td data-label="Status">
                        {order.status?.toLowerCase() === "confirmed" ? (
                          <span className="text-success fs-4">
                            <i className="bi bi-check-circle-fill"></i>
                          </span>
                        ) : order.status?.toLowerCase() === "cancelled" ? (
                          <span className="text-danger fs-4">
                            <i className="bi bi-x-circle-fill"></i>
                          </span>
                        ) : (
                          <span className="text-warning fs-4">
                            <i className="bi bi-clock-history"></i>
                          </span>
                        )}
                      </td>

                      <td>
                        {isConfirmed ? (
                          downloaded[i] ? (
                            <span className="text-success fw-semibold">
                              <i className="bi bi-check-circle-fill me-1"></i>
                              Downloaded
                            </span>
                          ) : (
                            <button
                              onClick={(e) =>
                                handleDownloadClick(
                                  e,
                                  `${BASE_URL}${item.emb_file}`,
                                  item.design_code,
                                  i,
                                )
                              }
                              className="btn btn-teal btn-sm"
                            >
                              <i className="bi bi-download me-1"></i>
                              Download
                            </button>
                          )
                        ) : (
                          <span className="text-muted">Not Available</span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {showAdModal && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-dialog">
            <div className="custom-modal-content">
              <div className="modal-header-custom">
                <h2 className="modal-title">Unlocking Your Design</h2>
                <p>We provide 100% free designs thanks to our sponsors.</p>
              </div>

              <div className="ad-card">
                <div className="ad-badge">SPONSORED AD</div>
                <div className="ad-body">
                  {/* <h4 className="ad-brand">Premium Embroidery Supplies</h4>
            <p className="ad-offer">Upgrade your toolkit with 20% off all thread kits.</p> */}
                  <h4 className="ad-brand">Your Ads Here</h4>

                  <div className="ad-visual-placeholder">
                    {/* You can place an actual <img> here */}
                    <div className="pulse-loader"></div>
                  </div>
                </div>
              </div>

              <div className="action-section">
                {adTimer > 0 ? (
                  <div className="timer-wrapper">
                    <span className="timer-text">Preparing your file...</span>
                    <div className="timer-number">{adTimer}s</div>
                  </div>
                ) : (
                  <div className="download-ready-area">
                    <p className="ready-msg"> Your file is ready!</p>
                    <a
                      href={pendingDownloadUrl?.url}
                      className="btn-download-glow"
                      onClick={(e) => {
                        e.preventDefault();

                        const link = document.createElement("a");
                        link.href = pendingDownloadUrl.url;

                        let ext = "emb";

                        if (pendingDownloadUrl.url.includes(".zip"))
                          ext = "zip";
                        else if (pendingDownloadUrl.url.includes(".rar"))
                          ext = "rar";

                        link.download = `${pendingDownloadUrl.code}.${ext}`;

                        document.body.appendChild(link);
                        link.click();
                        link.remove();

                        setDownloaded((prev) => ({
                          ...prev,
                          [pendingDownloadUrl.index]: true,
                        }));

                        setShowAdModal(false);
                      }}
                    >
                      Download Now
                    </a>
                  </div>
                )}
              </div>

              <button
                className="btn-close-modal"
                onClick={() => setShowAdModal(false)}
              >
                Maybe later
              </button>
            </div>
          </div>
        </div>
      )}
      <style>{`
        .btn-teal { background-color: #00a99d; color: white; border: none; padding: 10px; }
        .design-img-box { overflow: hidden; position: relative; background: #f8f9fa; }
        
        /* BILLARY MIRROR (Zoom Lens) CSS */
    

        .object-fit-contain { object-fit: contain; }



/* Modal Box */
.custom-modal-content {
  background: #ffffff;
  width: 90%;
  max-width: 450px;
  border-radius: 24px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.2);
  position: relative;
  margin-left:16px;
}

.modal-title {
  font-weight: 800;
  color: #1e293b;
  margin-bottom: 8px;
  font-size: 1.5rem;
}

/* Ad Container Styling */
.ad-card {
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 16px;
  padding: 20px;
  margin: 25px 0;
  position: relative;
}

.ad-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #10334b;
  color: white;
  font-size: 10px;
  font-weight: bold;
  padding: 4px 12px;
  border-radius: 20px;
  letter-spacing: 1px;
}

.ad-brand {
  color: #132e4d;
  font-weight: 700;
  margin-top: 10px;
}

/* Timer Styling */
.timer-number {
  font-size: 2.5rem;
  font-weight: 800;
  color: #ef4444;
  margin-top: 10px;
}

/* Pulsing Loader Animation */
.pulse-loader {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #2e4563;
  border-radius: 50%;
  margin: 15px auto;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Glow Download Button */
.btn-download-glow {
  display: inline-block;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  color: white;
  text-decoration: none;
  padding: 15px 30px;
  border-radius: 12px;
  font-weight: bold;
  font-size: 1.1rem;
  width: 100%;
  box-shadow: 0 10px 15px -3px rgba(34, 197, 94, 0.4);
  transition: transform 0.2s ease;
}

.btn-download-glow:hover {
  transform: translateY(-2px);
  color: white;
}

.btn-close-modal {
  background: none;
  border: none;
  color: #94a3b8;
  margin-top: 20px;
  cursor: pointer;
  font-size: 0.9rem;
  text-decoration: underline;
}
      `}</style>
    </div>
  );
}
